export default "__VITE_ASSET__DVKSL0aZ__"